import type { IPackage } from '@/Interfaces/Packages/Package.interface';
import axios from 'axios';

const packagesEndpoint = '/packages';

export const fetchPackages = async () => {
  const response = await axios.get<IPackage[]>(packagesEndpoint);
  return response.data;
};
